import Filters from '@/utils/input/filters';
import { registerModuleFilters } from '@/utils/input/filters';

const CreatedDateFilter = {
  ...Filters.DateFilter,
  name: 'created',
  label: 'global.created',
};

const UserCreatorFilter = {
  ...Filters.UserFilter,
  name: 'userCreatorId',
  label: 'global.userCreator',
};

const UpdatedDateFilter = {
  ...Filters.DateFilter,
  name: 'updated',
  label: 'global.updated',
};

const UserModifierFilter = {
  ...Filters.UserFilter,
  name: 'userModifierId',
  label: 'global.userModifier',
};

export const groupsFiltersConfig = [
  Filters.IsActiveFilter,
  CreatedDateFilter,
  UserCreatorFilter,
  UpdatedDateFilter,
  UserModifierFilter,
];

registerModuleFilters('customListGroups', groupsFiltersConfig);

export default groupsFiltersConfig;
